import { JobMixApi } from "api"
import { mappingData } from "pages/Master/JobMixDesign/functions"
import { useQuery } from "react-query"

export const useDropdownBarangJadi = () => useQuery(
  ["dropdownBarangJadi"],
  async () => {
    const res = await JobMixApi.dropdown({ tipe: "barang_jadi" })
    return mappingData(res, "barang_jadi", "kode_barang_jadi")
  },
  { refetchOnWindowFocus: false }
)

export const useDropdownUnitProduksi = () => useQuery(
  ["dropdownUnitProduksi"],
  async () => {
    const res = await JobMixApi.dropdownUnitProduksi()
    return res.data.data.map((val) => ({
      label: val?.nama_unit_produksi,
      value: val?.id_unit_produksi,
    }))
  },
  { refetchOnWindowFocus: false }
)

export const useDropdownGudang = (params) => useQuery(
  ["dropdownGudang", params],
  async () => {
    const res = await JobMixApi.dropdown({ tipe: "d_gudang", ...params })
    return mappingData(res, "gudang", "kode_gudang")
  },
  { refetchOnWindowFocus: false }
)